import { TOOLS, PROPERTY_TYPES, FLIPPED_HORIZONTALLY_FLAG, FLIPPED_VERTICALLY_FLAG, FLIPPED_DIAGONALLY_FLAG } from '../utils/constants.js';
import { qsa, qs, el } from '../utils/dom.js';

/**
 * Toolbar — tool selection buttons, property type sub-toolbar,
 * brush size indicator, and tile flip/rotate indicator.
 */
export class Toolbar {
  constructor(state) {
    this.state = state;
    this._propertySelector = null;
    this._bindButtons();
    this.state.onChange('activeTool', (tool) => this._updateActive(tool));
    this.state.onChange('brushSize', (size) => this._updateBrushSize(size));
    this.state.onChange('tileFlipFlags', (flags) => this._updateFlipIndicator(flags));
  }

  _bindButtons() {
    const buttons = qsa('.tool-btn[data-tool]');
    for (const btn of buttons) {
      btn.addEventListener('click', () => {
        const tool = btn.dataset.tool;
        this.state.set('activeTool', tool);
        this._updateStatusTool(tool);
      });
    }
  }

  _updateActive(tool) {
    const buttons = qsa('.tool-btn[data-tool]');
    for (const btn of buttons) {
      btn.classList.toggle('active', btn.dataset.tool === tool);
    }
    this._updateStatusTool(tool);
    this._togglePropertySelector(tool === TOOLS.PROPERTY);
  }

  _updateStatusTool(tool) {
    const statusEl = qs('#status-tool');
    if (statusEl) statusEl.textContent = `Tool: ${tool.charAt(0).toUpperCase() + tool.slice(1)}`;
  }

  _updateBrushSize(size) {
    const indicator = qs('#brush-size-indicator');
    if (indicator) {
      indicator.textContent = size > 1 ? `${size}×${size}` : '1×1';
      indicator.classList.toggle('active', size > 1);
    }
  }

  _updateFlipIndicator(flags) {
    const indicator = qs('#flip-indicator');
    if (!indicator) return;
    const parts = [];
    if (flags & FLIPPED_HORIZONTALLY_FLAG) parts.push('H');
    if (flags & FLIPPED_VERTICALLY_FLAG) parts.push('V');
    if (flags & FLIPPED_DIAGONALLY_FLAG) parts.push('R');
    indicator.textContent = parts.length > 0 ? parts.join('+') : '';
    indicator.classList.toggle('active', parts.length > 0);
  }

  _togglePropertySelector(show) {
    if (show && !this._propertySelector) {
      const toolbar = qs('#toolbar');
      if (!toolbar) return;

      const wrapper = el('div', { className: 'property-type-selector' });
      const label = el('span', { className: 'property-type-label' }, 'Type:');
      const select = el('select', { className: 'property-type-select' });

      for (const [key, value] of Object.entries(PROPERTY_TYPES)) {
        select.appendChild(el('option', { value }, key.charAt(0) + key.slice(1).toLowerCase()));
      }

      const currentType = this.state.get('propertyBrushType') || PROPERTY_TYPES.COLLISION;
      select.value = currentType;

      select.addEventListener('change', () => {
        this.state.set('propertyBrushType', select.value);
      });

      wrapper.append(label, select);
      toolbar.appendChild(wrapper);
      this._propertySelector = wrapper;
    } else if (!show && this._propertySelector) {
      this._propertySelector.remove();
      this._propertySelector = null;
    }
  }
}
